import React from 'react';
import { Container, Row, Col } from 'bootstrap-4-react';
import portfolioHero from "../../images/portfolio-hero.jpg";
import sample from "../../images/homepage.jpg";
import Slide from 'react-reveal/Slide';
import HeroSection from '../../Components/HeroSection/HeroSection';
import Header from '../../Header/Header';
import "../PortfolioPage.css";
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class Moja extends React.Component {
    componentDidMount() {
        ReactGA.pageview('/moja/');
    }
    render() {
        window.scrollTo(0, 0);
        return (
            <div className="portfolio-page">
                <Header />
                <HeroSection pageTitle="Case Studies" background={portfolioHero} />
                <section className='single-portfolio'>
                    <Container>
                        <Row>
                            <Col col="md-4 12" offset="md-1" className="project-image no-height">
                                <img width="100%" src={sample}/>
                            </Col>
                            <Col col="md-7 12" className="text-left">
                                <h1>MOJA1 Lucky Games</h1>
                                <p className="project-description">
                                MOJA1 is a specialist provider of financial technology and mobile money products and services in Africa. We have worked in partnership with MOJA1 from the outset of their mobile and online lotteries, games of chance and sports betting businesses in Africa.
                                <br/><br/>
                                The first step in making the MOJA1 gaming and lottery brands the success stories they are today was our detailed and comprehensive analysis of the online and mobile markets. Beginning in Tanzania, we concluded that there were significant potential customer groups who were not being served effectively by the incumbents, mostly through geographic and technology coverage. We determined that MOJA1’s product offering should be truly national in coverage in the countries in which it operates. We subsequently established partnerships with the leading telecoms providers to ensure MOJA1 can provide the broadest possible access to customers employing USSD, SMS and web technology.
                                <br/><br/>
                                Following the success in Tanzania, we have been engaged by MOJA1 to build and develop its business in Uganda, Kenya and across Africa.

                                </p>
                                <div className="info-project">
                                    <span className="info">
                                        <i className="fa fa-map-marker"></i>
                                        <span>Africa, Tanzania</span>
                                    </span>
                                    <span className="info">
                                        <i className="fa fa-calendar"></i>
                                        <span>2017</span>
                                    </span>
                                </div>
                                <a className="visit-project" href="http://www.mojabet.com" target="_blank">Check Project</a>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Footer/>
            </div>
        );
    }
}
export default Moja;
